module.exports = __webpack_public_path__ + "static/media/main_03.0830cd6f.png";